var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBackwardItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 7.85c0 1.84-.56 2.4-2.4 2.4h-2.7c-1.84 0-2.4-.56-2.4-2.4v-2.7c0-1.84.56-2.4 2.4-2.4h2.7c1.84 0 2.4.56 2.4 2.4v2.7zM10.25 18.85c0 1.84-.56 2.4-2.4 2.4h-2.7c-1.84 0-2.4-.56-2.4-2.4v-2.7c0-1.84.56-2.4 2.4-2.4h2.7c1.84 0 2.4.56 2.4 2.4v2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.63 13.621c0 2.28-.73 3.01-3.01 3.01h-1.39a.48.48 0 0 1-.48-.48c0-2.66-1.24-3.9-3.9-3.9a.48.48 0 0 1-.48-.48v-1.39c0-2.28.73-3.01 3.01-3.01h1.39a.48.48 0 0 1 .48.48c0 2.66 1.24 3.9 3.9 3.9a.48.48 0 0 1 .48.48v1.39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBackwardItem);
export default __webpack_public_path__ + "static/media/vuesax-bold-backward-item.738df66d37c57b6328914f2b5de0ff31.svg";
export { ForwardRef as ReactComponent };